import { Flex } from '@applyboard/crystal-ui';
import { queryParameterContext } from '../context';

import { PageHeader } from '../../../components/PageHeader';
import {
  ProgramsPagination,
  ProgramsTable,
  ProgramLevelFilter,
  QueryFilter,
  FieldOfStudyFilter,
  Sort,
} from '../components';

export function MobileLayout() {
  return (
    <Flex p={4} gap={4} direction="column">
      <PageHeader title="Program Catalog" />
      <Filter as={<QueryFilter />} width="100%" />
      <Filter as={<ProgramLevelFilter />} width="100%" />
      <Filter as={<FieldOfStudyFilter />} width="100%" />
      <Filter as={<Sort />} width="100%" />
      <Flex pt={2}>
        <queryParameterContext.FilterSummary />
      </Flex>
      <ProgramsTable />
      <ProgramsPagination />
    </Flex>
  );
}

function Filter(props: { as: React.ReactNode; width: string }) {
  return <div style={{ width: props.width }}>{props.as}</div>;
}
